import styled, { keyframes } from "styled-components";


export const IconUpDown = keyframes`
  0%, 100% {
    transform: translateY(3px);
    }
  50% {
    transform: translateY(-3px);
  }
`;

export const StyledSideBar = styled.nav`

ul.tma__nav_links{
    list-style:none;
    display:flex;
    flex-direction:column;
    li.tma__nav_link_item{
    width:100%;
    margin-bottom: 5px;
    cursor:pointer;
    transition: all 0.5s ease-in-out;
        a{
            color: white;
            text-decoration:none;
            padding: 1rem 0.8rem;
            display:block;
            width:100%;
            height:100%;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            svg{
                height:20px;
                width:20px;
            }
            span {display: flex; text-transform: uppercase; font-weight: 500;}

        }
    }
     li.tma__nav_link_item.active-item,li.tma__nav_link_item.active-item:hover{
         background-color: rgba(255,255,255,0.1);
         a{
            color: white;
         }
    }
    li.tma__nav_link_item:hover{
         background-color: rgba(255,255,255,0.1);
         a{
            color: white;
            span {
                svg {
                    animation: ${IconUpDown} 1s linear infinite;
                }
            }
         }
    }
    
}
`